import axios from 'axios'
import { clearToken, getUsableToken } from './token'

const isApiRequest = (url?: string) => {
  const apiBase = process.env.NEXT_PUBLIC_API_URL
  return !!apiBase && !!url && url.startsWith(apiBase)
}

export const requestInterceptor = () => {
  axios.interceptors.request.use(
    function (config: any) {
      // Attach the app token ONLY for our API — the old interceptor leaked
      // the auth token to every third-party host (DatoCMS, Zapier, …)
      if (isApiRequest(config.url)) {
        const token = getUsableToken()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )
}

export const responseInterceptor = () => {
  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      const status = error?.response?.status
      const url: string | undefined = error?.config?.url
      // Expired/invalid session → back to login. /auth/* 401s are flow
      // errors (wrong code, dead link) that the pages handle themselves.
      if (
        status === 401 &&
        isApiRequest(url) &&
        !url?.includes('/auth/') &&
        typeof window !== 'undefined'
      ) {
        clearToken()
        const path = window.location.pathname
        if (path !== '/login') {
          const redirect = encodeURIComponent(
            path + window.location.search,
          )
          window.location.href = `/login?loginRedirect=${redirect}`
        }
      }
      return Promise.reject(error)
    },
  )
}
